export default "__VITE_ASSET__CN_3kiiq__"